import { render, staticRenderFns } from "./OrderReturnSuccessPage.vue?vue&type=template&id=57908030"
import script from "./OrderReturnSuccessPage.vue?vue&type=script&lang=js"
export * from "./OrderReturnSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports